import { defineComponent as _defineComponent } from 'vue'
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { usePlaidLink, preloadPlaid } from 'ah-common-lib/src/plaid';
import IntegrationsListing from '../../integrations/IntegrationsListing.vue';
import { VButton } from 'ah-common-lib/src/common/components';
import { useToast } from 'ah-common-lib/src/toast';
import { computed, ref } from 'vue';
import { format } from 'date-fns';
import {
  ClientIntegration,
  IntegrationState,
  IntegrationType,
  PaginatedParams,
  PaginatedResponse,
} from 'ah-api-gateways';
import { useAhTradesState } from '../../..';
import StatusPill from 'ah-common-lib/src/common/components/StatusPill.vue';
import ArrowRightIcon from 'ah-common-lib/src/icons/components/ArrowRightIcon.vue';
import ExclamationCircleIcon from 'ah-common-lib/src/icons/components/ExclamationCircleIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreditFacilityPlaidIntegration',
  props: {
  includeRevoked: {
    type: [Boolean, String],
    default: false,
  },

  striped: {
    type: [Boolean, String],
    default: false,
  },
},
  setup(__props) {

const props = __props;

const STATUS_COLORS: Record<IntegrationState, string> = {
  [IntegrationState.ACTIVE]: 'success',
  [IntegrationState.REVOKED]: 'danger',
};

const STATUS_LABELS: Record<IntegrationState, string> = {
  [IntegrationState.ACTIVE]: 'Active',
  [IntegrationState.REVOKED]: 'Revoked',
};



const reqManager = useRequestManager().manager;
const tradeState = useAhTradesState();
const toast = useToast();

const integrationsListing = ref<InstanceType<typeof IntegrationsListing>>();
const plaidIntegrationData = ref<Partial<PaginatedResponse<ClientIntegration>>>();

const listConfig = {
  tableFields: [
    {
      header: 'Institution Name',
      key: 'presentationName',
      sortable: true,
    },

    {
      header: 'Validation Date',
      key: 'createdAt',
      sortable: true,
    },
    {
      header: 'Status',
      key: 'state',
    },
  ],
};

const defaultSortAndPageParams = {
  sort: 'createdAt',
  sortDirection: 'DESC',
} as Partial<PaginatedParams>;

const listFilter = computed(() => {
  const out: Record<string, any> = {
    integration: IntegrationType.PLAID,
  };

  if (props.includeRevoked === false) {
    out.state = IntegrationState.ACTIVE;
  }

  return out;
});

const hasPlaidIntegrations = computed(() => {
  return !!plaidIntegrationData.value?.total;
});

preloadPlaid();

function addPlaidIntegration() {
  reqManager
    .cancelAndNew('getPlaidToken', tradeState.services.integrations.requestPlaidLinkToken())
    .subscribe((tokenData) => {
      const plaidLink = usePlaidLink({
        token: tokenData.linkToken,
        onExit: () => {
          plaidLink.destroy();
        },
        onSuccess: (publicToken) => {
          reqManager
            .new('exchangePlaidToken', tradeState.services.integrations.exchangePlaidPublicToken(publicToken))
            .subscribe(() => {
              toast.success('Plaid integration successfully added');
              integrationsListing.value?.loadData();
              plaidLink.destroy();
            });
        },
      });

      plaidLink.open();
    });
}

return { __sfc: true,STATUS_COLORS, STATUS_LABELS, props, reqManager, tradeState, toast, integrationsListing, plaidIntegrationData, listConfig, defaultSortAndPageParams, listFilter, hasPlaidIntegrations, addPlaidIntegration, IntegrationsListing, VButton, format, StatusPill, ArrowRightIcon, ExclamationCircleIcon }
}

})